
    var riot = require('riot')
    
import _ from 'lodash'
riot.tag2('corona-info', '<div class="c-corona-info" if="{state.entry}"> <div class="c-corona-info__mv"><img alt="{state.entry.mv.name}" riot-src="{state.entry.mv.img}"></div> <div>{state.entry.mv.name}</div> <div class="c-corona-info__btn">{state.entry.season.name}</div> <div class="c-corona-info__btn">{state.entry.events.name}</div> <div>{state.entry.mv.name}</div> <div class="c-corona-info__btn">{state.entry.plans.name}</div> <div class="c-corona-info__btn">{state.entry.activities.name}</div> </div>', 'corona-info .c-corona-info__mv img,[data-is="corona-info"] .c-corona-info__mv img{ display: block; width: 100%; height: auto; } corona-info .c-corona-info__btn,[data-is="corona-info"] .c-corona-info__btn{ border: 1px solid #ddd; }', '', function(opts) {

    const self = this
    const sheet_id = '1fvr573fK7uy17ZhjgCw1W2RMX_GprYJjBH-WdGEbPyg'
    const api_url = 'http://sheets-api.k8s.ekzm.net/api'

    self.state = {
      entry: null
    }

    self.getSheets = () => {
      $.ajax({
        url: `${api_url}/${sheet_id}/corona`
      })
      .done( res => {
        self.state.entry = _.keyBy(res, 'id')
        self.update()

        console.log(self)
      })
    }

    self.on('mount', () => {
      self.getSheets()
    })

});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/corona-info/corona-info.tag